import React, { Component, ReactNode } from 'react';

import { ButtonProps } from '@material-ui/core/Button';
import Popover, { PopoverProps } from '@material-ui/core/Popover';

import Button from '../Button';

interface IProps {
  buttonContent: ReactNode | string;
  buttonProps?: ButtonProps;
  popoverProps?: Partial<PopoverProps>;
  children: ReactNode;
  id: string | number;
  origin?: 'left' | 'center' | 'right';
}

interface IState {
  anchorInfo: any;
}

class PopoverButton extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      anchorInfo: null
    };
  }

  public openInfo = (event: any) => {
    this.setState({ anchorInfo: event.currentTarget });
  };

  public closeInfo = () => {
    this.setState({ anchorInfo: null });
  };

  public render(): JSX.Element {
    const { children, id, origin, buttonProps = {}, popoverProps, buttonContent } = this.props;
    const { anchorInfo } = this.state;

    const paperClass = (popoverProps && popoverProps.classes && popoverProps.classes.paper) || '';

    const childrenWithProps = React.Children.map(children, child =>
      React.cloneElement(child as any, { onClose: this.closeInfo })
    );

    return (
      <>
        <Button
          {...buttonProps}
          className={`popover-button-button ${buttonProps.className || ''}`}
          aria-owns={`popper--button${id}`}
          aria-haspopup="true"
          onClick={this.openInfo}
        >
          {buttonContent}
        </Button>

        <Popover
          {...popoverProps}
          className={`popover-button-popover ${
            popoverProps && popoverProps.className ? popoverProps.className : ''
          }`}
          id={`popover-button-${id}`}
          classes={{
            paper: `popover-button-paper ${origin || 'left'} ${paperClass}`
          }}
          open={!!anchorInfo}
          anchorEl={anchorInfo}
          onClose={this.closeInfo}
          anchorOrigin={{
            horizontal: origin || 'left',
            vertical: 'bottom'
          }}
          transformOrigin={{
            horizontal: origin || 'left',
            vertical: 'top'
          }}
        >
          <div>{childrenWithProps}</div>
        </Popover>
      </>
    );
  }
}

export { PopoverButton };
